import type { ListScheduledPostsResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function listScheduledPosts(): Promise<ListScheduledPostsResponse> {
  return apiClient.url("/social-publishing/scheduled-posts").get().json();
}

export function useScheduledPosts(): UseQueryResult<
  ListScheduledPostsResponse,
  Error
> {
  return useQuery({
    queryFn: listScheduledPosts,
    queryKey: socialPublishingKeys.scheduledPosts(),
  });
}
